import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetLikedUsersSucceed, EGetLikedUsersActionType, IGetLikedUsersSucceedParams } from './types';

export const getLikedUsersSucceed: (data: IGetLikedUsersSucceedParams) => TGetLikedUsersSucceed = actionGenerator<
  EGetLikedUsersActionType.Succeed,
  IGetLikedUsersSucceedParams
>(EGetLikedUsersActionType.Succeed);
